
export const POST_USER_CRED_REQUEST = "POST_USER_CRED_REQUEST"
export const POST_USER_CRED_SUCCESS = "POST_USER_CRED_SUCCESS"
export const POST_USER_CRED_FAILURE = "POST_USER_CRED_FAILURE"

export const GET_USER_CART_REQUEST = "GET_USER_CART_REQUEST"
export const GET_USER_CART_SUCCESS = "GET_USER_CART_SUCCESS"
export const GET_USER_CART_FAILURE = "GET_USER_CART_FAILURE"


export const POST_USER_ORDER_REQUEST = "POST_USER_ORDER_REQUEST"
export const POST_USER_ORDER_SUCCESS = "POST_USER_ORDER_SUCCESS"
export const POST_USER_ORDER_FAILURE = "POST_USER_ORDER_FAILURE"

